interface SeoTitleProps {
  title: string;
}

/**
 * Отдаёт настоящий тег <title>. React 19 автоматически поднимает его в <head>,
 * а при пре-рендере он попадает в статичный HTML (в отличие от useEffect,
 * который выполняется только в браузере). Это единый источник заголовка
 * страницы, чтобы title/description не рассинхронизировались в исходном коде.
 */
export default function SeoTitle({ title }: SeoTitleProps) {
  return <title>{title}</title>;
}